export default __webpack_public_path__ + "static/media/education-analytics.9eee060c.svg";